
import React, { Component } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import ToggleSwitch from './ToggleSwitch';

class Period extends Component {
    constructor(props) {
        super(props)
        this.state = {
            monthlyPeriods: this.getMonthlyPeriods(),
            quarterlyPeriods: this.getQuarterlyPeriods(),
            retentionYears: this.getRetentionYears(),

        }
    }
    renderPeriodOptions() {
        const options = (this.props.mode === 'M') ? this.state.monthlyPeriods : this.state.quarterlyPeriods;
        return options.map((option, index) =>
            <option key={index} value={option.value}>{option.label}</option>)
    }
    render() {
        return (
            <>

                <Row>
                    {/* <Form.Group as={Col} >
                    <Form.Check size='lg' controlId="quarterly" label='Quarterly' type="radio" style={{ fontWeight: 'bold' }} />
                    <Form.Check size='lg' controlId="monthly" label='Monthly' type="radio" style={{ fontWeight: 'bold' }} />
                </Form.Group> */}
                </Row>

                {/* <ToggleSwitch label="Quarterly" onLabel="Quarterly" offLabel="Monthly"></ToggleSwitch> */}


                <Form.Row>
                    <Col sm={2} md={2}>
                        <Form.Label size='sm' style={{ fontWeight: 'bold' }}>Period From</Form.Label>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="periodSchedFrom">
                            <Form.Control as="select" size='sm' disabled={this.props.disabled}>
                                {this.renderPeriodOptions()}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="periodYearFrom">
                            <Form.Control as="select" size='sm' disabled={this.props.disabled}>
                                {this.state.retentionYears.sort((a, b) => a < b).map((option, index) =>
                                    <option key={index} value={option}>{option}</option>)
                                }
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Form.Row>

                <Form.Row>
                    <Col sm={2} md={2}>
                        <Form.Label size='sm' style={{ fontWeight: 'bold' }}>Period To</Form.Label>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="periodSchedTo">
                            <Form.Control as="select" size='sm' disabled={this.props.disabled}>
                                {this.renderPeriodOptions()}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="periodYearTo">
                            <Form.Control as="select" size='sm' disabled={this.props.disabled}>
                                {this.state.retentionYears.sort((a, b) => a < b).map((option, index) =>
                                    <option key={index} value={option}>{option}</option>)
                                }
                            </Form.Control>
                        </Form.Group>
                    </Col>


                </Form.Row>
            </>

        );
    }



    getMonthlyPeriods() {
        const monthlyPeriods = [
            {
                label: 'January',
                value: '01'
            },
            {
                label: 'February',
                value: '02'
            },
            {
                label: 'March',
                value: '03'
            },
            {
                label: 'April',
                value: '04'
            },
            {
                label: 'May',
                value: '05'
            },
            {
                label: 'June',
                value: '06'
            },
            {
                label: 'July',
                value: '07'
            },
            {
                label: 'August',
                value: '08'
            },
            {
                label: 'September',
                value: '09'
            },
            {
                label: 'October',
                value: '10'
            },
            {
                label: 'November',
                value: '11'
            },
            {
                label: 'December',
                value: '12'
            }
        ]
        return monthlyPeriods;
    }

    getQuarterlyPeriods() {
        const quarterlyPeriods = [
            {
                label: '1st quarter',
                value: '1'
            },
            {
                label: '2nd quarter',
                value: '2'
            },
            {
                label: '3rd quarter',
                value: '3'
            },
            {
                label: '4th quarter',
                value: '4'
            }
        ];
        return quarterlyPeriods;
    }

    getRetentionYears() {
        var year = (new Date()).getFullYear();
        var yr = [];
        for (var i = year; i >= 2008; i--) {
            yr[i] = i;
        }
        return yr;
    }
}

export default Period;